// const inPersonGPDrugList = ["stromectol"];
const inPersonGPDrugList = [];

export default inPersonGPDrugList;
